import { Fragment } from "react";
import { messageParts } from "@convex/notificationText";

/**
 * A notification's message, with the names in it set in italics -- an
 * activity or step title inside a sentence, marked where the message was
 * written (see convex/notificationText.ts). The digest does the same in HTML.
 */
export function NotificationMessage({ message }: { message: string }) {
  return (
    <>
      {messageParts(message).map((part, index) => (
        <Fragment key={index}>
          {part.isName ? <em>{part.text}</em> : part.text}
        </Fragment>
      ))}
    </>
  );
}
